import { Trans, useTranslation } from '@ecomm/i18n'

export const ProPlusDescription = () => {
  const { t } = useTranslation('maps')
  return <Trans t={t} i18nKey="plan-description.pro-plus" />
}
